import React from "react";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

const SectionWrapper: React.FC<ContainerProps> = ({ children, className = "" }) => {
  return (
    <div
      className={`
        px-auto
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default SectionWrapper;
